import type { BaseDocument } from '../mongo/base-document.interface';

export const CALL_STATUS = {
  ABANDONED: 'abandoned',
  CANCELLED: 'cancelled',
  DONE: 'done',
  IN_PROGRESS: 'inprogress',
  TODO: 'todo',
  TO_RETRY: 'to-retry',
} as const;

export type CallStatus = (typeof CALL_STATUS)[keyof typeof CALL_STATUS];

export interface CallSummaryRequest {
  body: unknown;
  headers: Record<string, string>;
  method: string;
  url: string;
}

export interface CallSummaryResponse {
  body: unknown;
  headers: Record<string, string>;
  message?: string;
  statusCode: number;
  timestamp: Date;
  url: string;
}

export interface CallSummary {
  request: CallSummaryRequest;
  response: CallSummaryResponse;
  /** True when the call pipeline decided not to send this call (e.g. sent-status ledger gating). */
  skipped?: boolean;
  success: boolean;
  url: string;
}

export interface CallRequest extends BaseDocument {
  calls: CallSummary[];
  correlationId: string;
  incomingEventId: string;
  /** Free-form out-of-band signalling carried over from the originating PharosMessage (e.g. `{ resendStatus: true }`). */
  metadata?: Record<string, unknown>;
  nextCallDate: Date | null;
  processingTimeout: Date | null;
  status: CallStatus;
  webhookConfigId: string;
}

export type CreateCallRequest = Omit<CallRequest, 'createdAt' | 'deletedAt' | 'id' | 'tenantId' | 'updatedAt'>;
